export const INDICATOR_PX_WIDTH = 4;
export const TIMESTAMP_PX_DISTANCE = 5 * 60;
export const TIMESTAMP_INTERVAL_IN_MS = 300000;
